module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-welcome/home-welcome.component.scss
// module id = ./src/app/components/home/home-welcome/home-welcome.component.scss
// module chunks = main